import React, { useState } from 'react';
import './MaxCareRX.css';

const MaxCaremaxcarerx = () => {
    // Mock FAQ Data (Replace with actual FAQs later)
    const faqs = [
        { question: "What services do you offer?", answer: "We provide a wide range of services including custom consulting, support, and product solutions tailored to your business needs." },
        { question: "How can I contact support?", answer: "You can contact our support team via email at support@toptierbenefits.com" },
        { question: "What are your operating hours?", answer: "Our business operates Monday to Friday, from 8 AM to 6 PM CST." },
    ];

    // Expand/collapse FAQ answers
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="maxcarerx-container">
            <h1 className="maxcarerx-title">MaxCare RX</h1>

            {/* Link Box */}
            <a href="https://ca.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=089d4a36-cc14-4d48-ad35-42ea062ddd5b&env=ca&acct=e6b74557-3473-4b9f-856e-4ebef6b2b3c7&v=2" target="_blank" rel="noopener noreferrer" className="maxcarerx-box">
                <div className="maxcarerx-content">
                    <h2>PATIENT ENROLLMENT FORM</h2>
                </div>
            </a>

            {/* FAQ Section */}
            <div className="maxcarerx-faq-section">
                <h2 className="maxcarerx-faq-title">Frequently Asked Questions</h2>
                <div className="maxcarerx-faq-list">
                    {faqs.map((faq, index) => (
                    <div
                        key={index}
                        className={`maxcarerx-faq-item ${openIndex === index ? "active" : ""}`}
                        onClick={() => toggleFAQ(index)}
                    >
                        <div className="maxcarerx-faq-question">
                        <strong>{faq.question}</strong>
                        <span className="maxcarerx-faq-icon">{openIndex === index ? "-" : "+"}</span>
                        </div>
                        <div className={`maxcarerx-faq-answer ${openIndex === index ? "show" : ""}`}>
                        {faq.answer}
                        </div>
                    </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MaxCaremaxcarerx;